<header id="header">
  <div class="top-left-div">
    <div id="logo-container">
      <!-- PLACE YOUR LOGO HERE -->
      <span id="logo" [ngClass]="{'redBG':instance=='wag'}">
        <img [src]="logo" [alt]="imgAlt">
      </span>
      <!-- END LOGO PLACEHOLDER -->
    </div>
    <sa-collapse-menu></sa-collapse-menu>
    <sa-application-menu></sa-application-menu>
    <div class="maintenance" *ngIf="test_env">
      TEST
    </div>
  </div>

  <div id="header-options" class="pull-right">

    <!-- logout button -->
    <sa-logout></sa-logout>
    <!-- end logout button -->

    <div class="pull-right logo-group-style" id="header-right-btn-group">
      <!-- help component -->
      <app-tutorial></app-tutorial>

      <!-- fullscreen button -->
      <sa-full-screen></sa-full-screen>
      <!-- end fullscreen button -->

      <sa-setting-menu></sa-setting-menu>

      <sa-activities></sa-activities>
      <sa-cart></sa-cart>
      <sa-company-list></sa-company-list>
    </div>


    <!-- #MOBILE -->

    <!-- Top menu profile link : this shows only when top menu is active -->
    <ul id="mobile-profile-img" class="header-dropdown-list hidden-xs padding-5">
      <li class="">
        <a *ngIf="profilePhoto" href="#" class="dropdown-toggle no-margin userdropdown" data-toggle="dropdown">
          <img [src]="profilePhoto" alt="me" class="online" />
        </a>
        <ul class="dropdown-menu pull-right">
          <li>
            <a (click)="(null)" class="padding-10 padding-top-0 padding-bottom-0"><i class="fa fa-cog"></i> Setting</a>
          </li>
          <li class="divider"></li>
          <li>
            <a routerLink="settings/usermanager/myprofile" class="padding-10 padding-top-0 padding-bottom-0"> <i
                class="fa fa-user"></i>
              <u>P</u>rofile</a>
          </li>
          <li class="divider"></li>
          <li>
            <a (click)="(null)" class="padding-10 padding-top-0 padding-bottom-0" data-action="toggleShortcut"><i
                class="fa fa-arrow-down"></i> <u>S</u>hortcut</a>
          </li>
          <li class="divider"></li>
          <li>
            <a (click)="(null)" class="padding-10 padding-top-0 padding-bottom-0" data-action="launchFullscreen"><i
                class="fa fa-arrows-alt"></i> Full <u>S</u>creen</a>
          </li>
          <li class="divider"></li>
          <li>
            <a (click)="logout()" class="padding-10 padding-top-5 padding-bottom-5" data-action="userLogout"><i
                class="fa fa-sign-out fa-lg"></i> <strong><u>L</u>ogout</strong></a>
          </li>
        </ul>
      </li>
    </ul>


    <!-- multiple lang dropdown : find all flags in the flags page -->
    <sa-language-selector></sa-language-selector>
    <!-- end multiple lang -->

    <div class="theme-mode-toggle" [class.dark]="isDarkMode" role="tablist" aria-label="Theme mode">
      <button type="button" class="theme-mode-btn" [class.active]="isDarkMode" (click)="setThemeMode(true)"
        title="Dark mode" aria-label="Dark mode">
        <i class="fa fa-moon-o" aria-hidden="true"></i>
      </button>
      <button type="button" class="theme-mode-btn" [class.active]="!isDarkMode" (click)="setThemeMode(false)"
        title="Light mode" aria-label="Light mode">
        <i class="fa fa-sun-o" aria-hidden="true"></i>
      </button>
      <span class="theme-mode-thumb" aria-hidden="true"></span>
    </div>


    <button (click)="backTo()" class="portal-redirect-btn btn-primary btn--outlined header-style" style="float: left;">
      <span class="material-icons-outlined arrow_back_hdr">
        arrow_back
      </span><span class="sec_hedr_prtl">{{'header_backto_portal' |
        i18n}}</span></button>
    <!-- <div class="sticky-notes sticky-notes-style">
      <a title="{{'common_all_StickyNotes' | i18n}}">
        <i class="fa fa-sticky-note txt-color-blueDark" aria-hidden="true"></i>
      </a>
      <a (click)="showstickynotes()" title="{{'common_all_AddStickyNotes' | i18n}}">
        <i class="fa fa-plus txt-color-blueDark" aria-hidden="true"></i>
      </a>
      <a *ngIf="toggleClass==true" (click)="showhidestickynotes()" class="changeiclass"
        title="{{'common_all_stickyNotes_show' | i18n}}">
        <i class="fa fa-eye-slash txt-color-blueDark" aria-hidden="true"></i>
      </a>
      <a *ngIf="toggleClass==false" (click)="showhidestickynotes()" class="changeiclass"
        title="{{'common_all_stickyNotes_hide' | i18n}}">
        <i class="fa fa-eye txt-color-blueDark" aria-hidden="true"></i>
      </a>
    </div> -->
    <!-- <div class="sticky-shortCuts sticky-notes-style">
      <a class="changeiclass linkIcon" title="{{'common_all_header_add_shortcuts' | i18n}}">
        <i class="fa fa-link txt-color-blueDark" aria-hidden="true"></i>
      </a>
      <div class="">

      </div>
      <p><b class="shortcutDark"> <i class="fa fa-link txt-color-blueDark" aria-hidden="true"></i>
          {{'common_all_header_shortcuts'|i18n}}</b></p>
      <div class="shortCutsDisplay">
        <div class="col-sm-12 col-md-4 col-lg-4" *ngFor="let shortCut of shortCuts">
          <a title="{{'common_remove' | i18n}}" class="deleteShortcut" (click)="deleteShortcut(shortCut.id)">
            <i class="fa fa-times" aria-hidden="true"></i>
          </a>
          <div class="well text-center connect shortCutBox shortCutBoxPopupOver"
            [attr.data-url]='shortCut.hoverLabelTemp' [attr.data-label]='shortCut.label' id="{{shortCut.path}}"
            data-toggle='popover' data-html='true' data-trigger='hover' data-container='body' data-placement='bottom'>
            <span *ngIf='shortCut.icon != ""' id="{{shortCut.path}}"><i
                class="apps-icon {{shortCut.icon}} fa fa-lg fa-fw {{shortCut.icon}} shorCutsIcons"
                id="{{shortCut.path}}"></i></span>
            <span *ngIf='shortCut.icon == ""' id="{{shortCut.path}}"><i
                class="apps-icon {{shortCut.icon}} fa fa-lg fa-link shorCutsIcons" id="{{shortCut.path}}"></i></span>
            <p class="shortcutsLabelText" id="{{shortCut.path}}">
              <span class="bookmarkLink_{{shortCut.id}} bookmarkLink renameShortcut" id="{{shortCut.path}}"
                [attr.data-id]="shortCut.id" style="cursor: text !important;">
                <i class="fa fa-pencil renameShortcut" aria-hidden="true" [attr.data-id]="shortCut.id"></i>
                {{shortCut.label}}
              </span>
              <input type="text" class="renameBookmarkLink" id="renameBookmarkLink_{{shortCut.id}}"
                [attr.data-id]="shortCut.id" name="rename" value="{{shortCut.label}}" hidden>
            </p>

          </div>
        </div>
      </div>
      <button type="submit" title="{{'common_all_header_addshortcut_message'|i18n}}"
        class="btn addLinkText shortcutDark">{{'common_all_header_addshortcut_message'|i18n}}</button>

    </div> -->

    <!-- Note container area -->
    <notes-container></notes-container>
    <!-- End of Note container area -->
  </div>
  <!-- end pulled right: nav area -->

</header>


<div bsModal #newBuild="bs-modal" class="modal fade mdModal serviceModel" id="lgModal" tabindex="-1" role="dialog"
  aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content interConnContent">

      <div class="crossDiv">
        <span class="modal-title" id="" style="font-size: 16px;font-weight: bold;">{{'newversion_available' |
          i18n}}</span>
        <div class="pull-right closeModal" (click)="newBuild.hide()">
          <a>
            <i class="fa fa-close crossBtn mr-4" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <div class="row  pl-4 pr-4 mr-0 mt-4">
        <div class="pl-4" style="font-size: 14px" [innerHTML]="buildAlert"></div>
        <div class="row w-100 mb-4 justify-content-end mt-4">
          <button class="btn-primary btnModalSave text-center floatRight" title="{{'common_clearcache_build' | i18n}}"
            (click)="clearCache()">{{'common_clearcache_build' | i18n}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #cookieError="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true" [config]="{backdrop: 'static'}" id="myModal">
  <div class="modal-dialog modal-sl modal-dialog-centered">
    <div class="modal-content modalBodyBgColor border" style="padding: 15px !important;  width: 800px;">
      <div class="modal-body modalBody p-0">
        <div class="modal-body modalBody payBody">
          <h4>{{'common_cookie_error'|i18n}}</h4>
        </div>
        <div class="MessageBoxButtonSection">

          <button id="bot2-Msg1" class="btn btn-default btn-sm botTempo"
            (click)="errorAlertOk()">{{'common_ok'|i18n}}</button>
        </div>
      </div>
    </div>
  </div>
</div>